import { useTranslation } from "react-i18next";
import { NullBadgeUrl } from "../../tools/utils";
import { OrganizationContactResponse } from "../../types/certWatch";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { setConnection } from "../../redux/slices/certConnectSlice";
import { getContactDesignations } from "../../redux/thunks/designationThunks";
import { openModal, toggleModal } from "../../redux/slices/modalSlice";

interface IContactCredentialCardProps {
  index: number | null;
  connection: OrganizationContactResponse;
}

export const MyConnectionCard = ({
  connection,
  index
}: IContactCredentialCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div className="cco_group_item tpCards" key={connection.ContactId + index}>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          dispatch(setConnection(connection));
          dispatch(openModal("connectionModal"));
          dispatch(getContactDesignations(connection.ContactId));
        }}
      >
        <div className="cco_card cco_card_myCredential">
          <div
            className="cco_card_body"
            style={{ display: "flex", alignItems: "stretch" }}
          >
            {/* Profile Photo */}
            <div className="cco_card_aside">
              <div className="cco_img">
                <span className="cco_img_wrap">
                  <img
                    style={{
                      border:
                        connection.ContactProfilePic != null
                          ? ""
                          : "1px solid rgb(0 0 0 / 5%)",
                      borderRadius: "10px",
                      height: "90px",
                      width: "130px",
                      objectFit: "cover"
                    }}
                    alt={connection?.ContactName}
                    src={
                      connection.ContactProfilePic != null
                        ? connection.ContactProfilePic
                        : NullBadgeUrl
                    }
                  />
                </span>
              </div>
            </div>

            {/* Main Content */}
            <div
              className="cco_card_main"
              style={{
                width: "100%",
                padding: "8px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              }}
            >
              <div className="cco_text cco_text_myCredential" style={{ flex: 1 }}>
                <div className="cco_text_inner">
                  <h3>
                    <strong>{connection?.ContactName}</strong>
                  </h3>

                  <div>
                    <div>
                      {t("MyCCOPro.SearchCandidate.ccoId")}:{" "}
                      {connection?.ContactCCOID}
                    </div>

                    <div
                      style={{
                        maxHeight: "100px",
                        overflow: "hidden"
                      }}
                    >
                      {/* ================== STATUS / BADGES ================== */}

                      {/* 🔒 LOCKED takes top priority */}
                      {connection?.StatusReason === "Approved" &&
                        connection?.CandidateAccessControl === "Locked" && (
                          <div
                            style={{
                              backgroundColor: "red",
                              color: "#fff",
                              padding: "1px 6px",
                              borderRadius: "4px",
                              fontSize: "14px",
                              display: "inline-block",
                              fontWeight: "bold"
                            }}
                          >
                            {t("MyCCOPro.SearchCandidate.lockerror")}
                          </div>
                        )}

                      {/* 🟡 Pending */}
                      {connection?.StatusReason === "Pending" && (
                        <div
                          style={{
                            backgroundColor: "yellow",
                            color: "#000",
                            padding: "1px 6px",
                            borderRadius: "4px",
                            fontSize: "14px",
                            display: "inline-block",
                            fontWeight: "bold"
                          }}
                        >
                          {t("MyCCOPro.SearchCandidate.pendingError")}
                        </div>
                      )}

                      {/* ✅ Approved (not locked) + Show Designations only if photo approved */}
                      {connection?.StatusReason === "Approved" &&
                        connection?.CandidateAccessControl !== "Locked" &&
                        connection?.IsPhotoApproved === true && (
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {connection?.MyCCODesignationDetails ? (
                              (() => {
                                const items =
                                  connection.MyCCODesignationDetails.split(",").map(
                                    (i) => i.trim()
                                  );
                                const firstFive = items.slice(0, 4);
                                const remaining = items.length - 4;

                                return (
                                  <>
                                    {firstFive.map((item, index) => (
                                      <span
                                        key={index}
                                        style={{
                                          backgroundColor: "#E37E33",
                                          color: "#fff",
                                          padding: "1px 6px",
                                          borderRadius: "4px",
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginRight: "4px",
                                          marginBottom: "4px",
                                          display: "inline-block"
                                        }}
                                      >
                                        {item}
                                      </span>
                                    ))}

                                    {remaining > 0 && (
                                      <span
                                        style={{
                                          backgroundColor: "#E37E33",
                                          color: "#fff",
                                          padding: "1px 6px",
                                          borderRadius: "4px",
                                          fontSize: "14px",
                                          marginRight: "4px",
                                          marginBottom: "4px",
                                          display: "inline-block",
                                          fontWeight: "bold"
                                        }}
                                      >
                                        +{remaining}
                                      </span>
                                    )}
                                  </>
                                );
                              })()
                            ) : (
                              <div
                                style={{
                                  backgroundColor: "grey",
                                  color: "#fff",
                                  padding: "1px 6px",
                                  borderRadius: "4px",
                                  fontSize: "14px",
                                  display: "inline-block",
                                  fontWeight: "bold"
                                }}
                              >
                                {t("MyCCOPro.SearchCandidate.none")}
                              </div>
                            )}
                          </div>
                        )}

                      {/* ❌ Approved but photo not approved — hide certifications */}
                      {connection?.StatusReason === "Approved" &&
                        connection?.CandidateAccessControl !== "Locked" &&
                        connection?.IsPhotoApproved === false && (
                          <div
                            style={{
                              backgroundColor: "yellow",
                              color: "#000",
                              padding: "1px 6px",
                              borderRadius: "4px",
                              fontSize: "14px",
                              display: "inline-block",
                              fontWeight: "bold"
                            }}
                          >
                            {t("MyCCOPro.SearchCandidate.photoNotApproved")}
                          </div>
                        )}
                      {/* ====================================================== */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
